import React from 'react';

// Components
import { Logo, Text, Button } from '@components';

// Styles

// Themes
import { main } from '@themes';

// Templates
import { SignUp } from '@templates';
import { Wrapper, InputSection, TitleSection } from './PassSuccess.styles';

const PassSuccess = () => {
  return (
    <>
      <SignUp titlePage="E-mail enviado" highlight=" ">
        <Wrapper>
          <div className="mobile-only">
            <Logo size="150px" />
          </div>

          <TitleSection>
            <Text
              as="h6"
              size="1.6rem"
              color={main.colorSystem.baseColor400}
              weight="bold"
              height="normal"
              dheight="normal">
              Redefinir Senha
            </Text>
            <Text
              as="h1"
              size="2rem"
              dsize="2.4rem"
              color={main.colorSystem.baseColor}
              family={main.fonts.fontFamily.serif}
              weight="bold"
              height="normal"
              dheight="normal"
              id="forgot-pass__text__headline">
              Você receberá um e-mail com instruções para redefinir sua senha.
            </Text>
          </TitleSection>
          <InputSection>
            <Button
              variant="primary"
              size="medium"
              link="internal"
              href="/login"
              id="forgot-pass__button__goback">
              Voltar
            </Button>
          </InputSection>
        </Wrapper>
      </SignUp>
    </>
  );
};

export { PassSuccess };
export default PassSuccess;
